module.exports = __webpack_public_path__ + "static/media/using-apps.bfd79712.mp4";